export enum WidthSize {
    EXTRA_SMALL = 352,
    SMALL = 480,
    MEDIUM = 664,
    LARGE = 768,
    EXTRA_LARGE = 872,
}
